import LinkedInLogo from './LinkedInLogo';

export default LinkedInLogo;
